import type { RegistryEntry } from '../../types';

export const nanoBananaConfigs: Record<string, RegistryEntry> = {
  'nano-banana-2-1': {
    options: [
      { key: 'google_search', label: 'Google Search', type: 'switch', default: false, group: 'advanced' },
      {
        key: 'output_format',
        label: 'Output Format',
        type: 'select',
        options: [
          { label: 'JPEG', value: 'jpeg' },
          { label: 'PNG', value: 'png' },
        ],
        default: 'jpeg',
        group: 'advanced',
      },
    ],
    toProviderOptions: (ui) => ({
      google_search: ui.google_search === true,
      output_format: typeof ui.output_format === 'string' ? ui.output_format : 'jpeg',
    } as unknown as Record<string, Record<string, any>>),
  },
  // Nano Banana 2 模型：支持 Google Search 与输出格式
  'nano-banana-2': {
    options: [
      { key: 'google_search', label: 'Google Search', type: 'switch', default: false, group: 'advanced' },
      {
        key: 'output_format',
        label: 'Output Format',
        type: 'select',
        options: [
          { label: 'JPEG', value: 'jpeg' },
          { label: 'PNG', value: 'png' },
        ],
        default: 'jpeg',
        group: 'advanced',
      },
    ],
    toProviderOptions: (ui) => ({
      google_search: ui.google_search === true,
      output_format: typeof ui.output_format === 'string' ? ui.output_format : 'jpeg',
    } as unknown as Record<string, Record<string, any>>),
  },
  // Nano Banana 模型：支持输出格式
  'nano-banana': {
    options: [
      {
        key: 'output_format',
        label: 'Output Format',
        type: 'select',
        options: [
          { label: 'PNG', value: 'png' },
          { label: 'JPEG', value: 'jpeg' },
        ],
        default: 'png',
        group: 'advanced',
      },
    ],
    toProviderOptions: (ui) => ({
      output_format: typeof ui.output_format === 'string' ? ui.output_format : 'png',
    } as unknown as Record<string, Record<string, any>>),
  },
};